import React, { Component, useState } from "react";
import { withRouter } from "react-router-dom";

import { renderRedirect } from "../util";
import DatePicker from "react-datepicker";
import {fetchSignApplication, updateSignApplication, sendEmail} from "./BasicProfile/api"
import { checkPanStatus, fetchKraDetails } from "./KYC/kraApi";
import $ from 'jquery';
import "react-datepicker/dist/react-datepicker.css";
import { spinnerService } from "../Components/spinner.service";
import Footer from "../Components/footer";

class PersonalDetails extends Component {
  renderRedirect = () => {
    renderRedirect(this.props, "/address");
  };

  constructor(props) {
    super(props);
    this.state = {
      dateOfBirth:  new Date(),
      fullName: null,
      panNumber: null,
      maritalStatus: null,
      gender: null,
      isValidated: false,
      kraAutofilled: false,
      kraLoading: false,
      kraMessage: "",
      errors: {
        fullName: "",
        dateOfBirth: "",
        panNumber: "",
        maritalStatus: "",
        gender: "",
      },
    };
  }
  validateForm = () => {
    if (
      this.state.fullName &&
      this.state.panNumber &&
      this.state.maritalStatus &&
      this.state.gender &&
      this.state.dateOfBirth
    ) {
      this.setState({ ["isValidated"]: true });
      console.log(this.state.isValidated);
      return true;
    } else {
      this.setState({ ["isValidated"]: false });
      console.log(this.state.isValidated);
      return false;
    }
  };

  async componentDidMount() {
    let profileData = await fetchSignApplication();
    if(profileData && profileData.data && profileData.data.fetch_signup_application){
      let data = profileData.data.fetch_signup_application;
      this.setState({["fullName"]: data.fullName});
      this.setState({["panNumber"]: data.pan});
      this.setState({["maritalStatus"]: data.martialStatus});
      this.setState({["gender"]: data.gender});
      console.log(data.dob);
      let date = data.dob ? decodeURIComponent(data.dob) : "";
      this.setState({["dateOfBirth"]: date});

      if (data.pan && data.pan.length === 10 && date) {
        this.checkAndFetchKra(data.pan, date);
      } else {
        this.validateForm();
      }
    }
  }

  checkKraOnInput = () => {
    const { panNumber, dateOfBirth, kraAutofilled, kraLoading } = this.state;
    if (kraAutofilled || kraLoading) return;

    if (panNumber && panNumber.length === 10 && dateOfBirth) {
      let dobStr = "";
      if (dateOfBirth instanceof Date) {
        const pad = (num) => String(num).padStart(2, '0');
        dobStr = `${pad(dateOfBirth.getDate())}/${pad(dateOfBirth.getMonth() + 1)}/${dateOfBirth.getFullYear()}`;
      } else if (typeof dateOfBirth === "string") {
        dobStr = dateOfBirth;
      }
      
      if (dobStr && dobStr.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        this.checkAndFetchKra(panNumber, dobStr);
      }
    }
  };

  checkAndFetchKra = async (pan, dob) => {
    if (!pan || pan.length !== 10) return;
    this.setState({ kraLoading: true, kraMessage: "Checking KRA database..." });
    try {
      const statusRes = await checkPanStatus(pan, dob);
      if (statusRes && statusRes.isKRAVerified) {
        const detailsRes = await fetchKraDetails(pan, dob);
        if (detailsRes && detailsRes.status) {
          this.setState({
            kraAutofilled: true,
            kraMessage: "KYC details auto-filled from KRA database!",
          });
          // Re-fetch updated profile
          let profileData = await fetchSignApplication();
          if (profileData?.data?.fetch_signup_application) {
            let data = profileData.data.fetch_signup_application;
            if (data.fullName) this.setState({ fullName: data.fullName });
            if (data.gender) this.setState({ gender: data.gender });
            if (data.martialStatus) this.setState({ maritalStatus: data.martialStatus });
            if (data.dob) this.setState({ dateOfBirth: decodeURIComponent(data.dob) });
          }
        } else {
          this.setState({
            kraMessage: detailsRes?.message || "Failed to fetch details from KRA database.",
          });
        }
      } else {
        this.setState({
          kraMessage: "No prior KRA record found. Please complete details manually.",
        });
      }
    } catch (err) {
      console.warn("KRA Check/Fetch Error:", err);
      this.setState({ kraMessage: err.message || "Error checking KRA database." });
    } finally {
      this.setState({ kraLoading: false });
      this.validateForm();
    }
  };
  
  handleChange = (event) => {
    let errors = this.state.errors;
    if (event instanceof Date) {
      console.log("Inside event" + event);
      errors.dateOfBirth = "";
      this.setState({ ["dateOfBirth"]: event }, () => {
        this.checkKraOnInput();
      });
      console.log("State DOB Value-" + event);
    } else if(event && event.target) {
      const { id, value } = event.target;
      switch (id) {
        case "fullName":
          if (value.length < 1) {
            //errors.fullName = "Full Name must be at least 5 characters long!";
            this.setState({ ["fullName"]: null });
          } else {
            errors.fullName = "";
            this.setState({ ["fullName"]: value });
          }
          break;
        case "panNumber":
          if (value.length < 1) {
            //errors.panNumber = "Pan number must be at least 8 characters long!";
            this.setState({ ["panNumber"]: null });
          } else {
            errors.panNumber = "";
            this.setState({ ["panNumber"]: value.toUpperCase() }, () => {
              this.checkKraOnInput();
            });
          }
          break;
        case "maritalStatus":
          if (value.length < 1) {
            //errors.maritalStatus = "Please choose a gender";
            this.setState({ ["maritalStatus"]: null });
          } else {
            errors.maritalStatus = "";
            this.setState({ ["maritalStatus"]: value });
          }
          break;
        case "gender":
          if (value.length < 1) {
           // errors.gender = "Gender must be at least 5 characters long!";
            this.setState({ ["gender"]: null });
          } else {
            errors.gender = "";
            this.setState({ ["gender"]: value });
          }
          break;
        default:
          break;
      }
    }
    this.setState({ errors });
    

    window.setTimeout(function () {
      this.validateForm();
    }.bind(this), 600);

    
  
  };

  handleSubmit = async(event) => {
    event.preventDefault();

    // Validate and show errors on empty required fields
    if (!this.validateForm()) {
      const errors = { ...this.state.errors };
      if (!this.state.fullName) errors.fullName = "Full Name is required";
      if (!this.state.panNumber) errors.panNumber = "PAN Number is required";
      if (!this.state.maritalStatus) errors.maritalStatus = "Marital Status is required";
      if (!this.state.gender) errors.gender = "Gender is required";
      if (!this.state.dateOfBirth) errors.dateOfBirth = "Date of Birth is required";
      this.setState({ errors }, () => {
        const firstError = document.querySelector('.error');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      return;
    }

    spinnerService.show("mainSpinner", "Please wait...");

    const pad = (num) => String(num).padStart(2, '0');
    let dobStr = "";
    if (this.state.dateOfBirth instanceof Date) {
      const d = this.state.dateOfBirth;
      dobStr = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
    } else if (typeof this.state.dateOfBirth === "string") {
      dobStr = this.state.dateOfBirth;
    }

    let reqParam = {
      dob: dobStr,
      fullName: this.state.fullName,
      pan: this.state.panNumber,
      martialStatus: this.state.maritalStatus,
      gender: this.state.gender,
    };
    let updateProfile = await updateSignApplication(reqParam);
    if(updateProfile){
      spinnerService.hide("mainSpinner");
      this.renderRedirect();
    }
    event.preventDefault();
  };

  render() {
    const { errors } = this.state;
    return (      <div className="col-md-6 col-lg-5 col-xl-4">

      <div className="container my-auto py-4 bg-white shadow-lg rounded">
        <div className="row mt-2">
          <div className="col-11 col-lg-11 mx-auto">
            <h1>Personal Details</h1>
            {this.state.kraMessage && (
              <div className={`alert ${this.state.kraAutofilled ? 'alert-success' : 'alert-info'} text-1 text-center py-2`}>
                {this.state.kraLoading && <span className="spinner-border spinner-border-sm mr-2" role="status"></span>}
                {this.state.kraMessage}
              </div>
            )}
            <form id="registerForm" className="form-border">
              <div className="form-group icon-group floating-label-wrap">
                <input
                  type="text"
                  className="form-control  floating-label-field floating-label-field--s1"
                  id="fullName"
                  required
                  value={this.state.fullName}
                  placeholder="Full Name"
                  onChange={this.handleChange}
                  onKeyUp={this.handleChange}
                  noValidate
                  readOnly={this.state.kraAutofilled}
                />
                                <label class="floating-label">Full Name</label>

                <span className="icon-inside text-primary">
                  <i className="fas fa-user"></i>
                </span>
                {errors.fullName.length > 0 && (
                  <span className="error">{errors.fullName}</span>
                )}
              </div>

              <div className="form-group icon-group floating-label-wrap">
                <select
                  id="gender"
                  className="form-control  floating-label-field floating-label-field--s1"
                  onChange={this.handleChange}
                  onKeyUp={this.handleChange}
                  noValidate
                  value={this.state.gender}
                  disabled={this.state.kraAutofilled}
                >                    <option value="">Select an option</option>

                  <option value="M">Male</option>
                  <option value="F">Female</option>
                  <option value="T">Transgender</option>
                </select>
                <label class="floating-label">Gender</label>

                <span className="icon-inside text-primary">
                  <i className="fas fa-venus-mars"></i>
                </span>
                {errors.gender.length > 0 && (
                  <span className="error">{errors.gender}</span>
                )}
              </div>
              <div className="form-group icon-group floating-label-wrap date-of-birth">
                <DatePicker
                  className="form-control floating-label-field floating-label-field--s1"
                  selected={this.state.dateOfBirth instanceof Date ? this.state.dateOfBirth : (this.state.dateOfBirth ? new Date(this.state.dateOfBirth.split("/").reverse().join("-")) : null)}
                  onChange={(date) => this.handleChange(date)}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Date of birth"
                  maxDate={new Date()}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  required
                  disabled={this.state.kraAutofilled}
                />
                <label class="floating-label">Date of birth</label>

                <span className="icon-inside text-primary">
                  <i className="fas fa-calendar"></i>
                </span>
                {errors.dateOfBirth && errors.dateOfBirth.length > 0 && (
                  <span className="error">{errors.dateOfBirth}</span>
                )}
              </div>

         
              <div className="form-group icon-group floating-label-wrap">
                <input
                  type="text"
                  className="form-control  floating-label-field floating-label-field--s1"
                  id="panNumber"
                  required
                  placeholder="PAN Number"
                  onChange={this.handleChange}
                  onKeyUp={this.handleChange}
                  noValidate
                  value={this.state.panNumber}
                  readOnly={this.state.kraAutofilled}
                />
                                <label class="floating-label">PAN Number</label>

                <span className="icon-inside text-primary">
                  <i className="fas fa-file"></i>
                </span>
                {errors.panNumber.length > 0 && (
                  <span className="error">{errors.panNumber}</span>
                )}
              </div>
              <div className="form-group icon-group floating-label-wrap">
                <select
                  id="maritalStatus"
                  className="form-control  floating-label-field floating-label-field--s1"
                  onChange={this.handleChange}
                  onKeyUp={this.handleChange}
                  noValidate
                  value={this.state.maritalStatus}
                >                    <option value="">Select an option</option>

                  <option value="Single">Single</option>
                  <option value="Married">Married</option>
                  <option value="Other">Other</option>
                </select>
                <label class="floating-label">Marital Status <span className="text-danger">*</span></label>
                <span className="icon-inside text-primary">
                  <i className="fas fa-users"></i>
                </span>
                {errors.maritalStatus.length > 0 && (
                  <span className="error">{errors.maritalStatus}</span>
                )}
              </div>

              <button
                className="btn btn-primary btn-block text-uppercase mt-4"
                type="button"
                onClick={this.handleSubmit}
                disabled={!this.state.isValidated || this.state.kraLoading}
              >
                NEXT
              </button>
            </form>
          </div>
        </div>
      </div><Footer /></div>
    );
  }
}
export default withRouter(PersonalDetails);